import { render, staticRenderFns } from "./ButtonLike.vue?vue&type=template&id=6d88348a&scoped=true"
import script from "./ButtonLike.vue?vue&type=script&lang=js"
export * from "./ButtonLike.vue?vue&type=script&lang=js"
import style0 from "./ButtonLike.vue?vue&type=style&index=0&id=6d88348a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88348a",
  null
  
)

export default component.exports